import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';

type PostUploadCnhParams = {
  deliverymanId: string;
  file: FormData;
};

const postUploadCnh = async ({ deliverymanId, file }: PostUploadCnhParams) =>
  apiClient
    .post(
      `entregadores/${deliverymanId}/send-deliveryman-cnh-picture-by-manager`,
      file,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    .then(response => {
      handleResponseSuccess(response, 'A CNH foi enviada com sucesso!')();
    })
    .catch(
      handleResponseThrowError('Não foi possível enviar a cnh do entregador.'),
    );

export const usePostUploadCnh = ({
  onSuccess,
}: { onSuccess?: () => void } = {}) => {
  return useMutation({
    mutationFn: postUploadCnh,
    onSuccess,
  });
};
